import { render, staticRenderFns } from "./OrderFormDataInput.vue?vue&type=template&id=245a2532"
import script from "./OrderFormDataInput.vue?vue&type=script&lang=js"
export * from "./OrderFormDataInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports